import React from "react";
import { Link } from "react-router-dom";
import Header from "./comman/Header";
import Footer from "./comman/Footer";
// import { Dropdown } from "react-bootstrap";

const HomePage = () => {
  return (
    <>
      <Header />

      <section className="hero-section">
        <video autoPlay muted loop id="videolayout">
          <source src="images/hero-video.mp4" type="video/mp4" />
        </video>
        <div className="hero-bannercontent">
          <div className="container">
            <div className="row">
              <div className="col-md-10">
                <h1>
                  Effortless printing, <br /> delivered to your doorstep.
                </h1>
              </div>
              <div className="col-md-2">
                <div className="banner-flyimg">
                  <img src="images/banner-fly-img.svg" alt="/" />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-9">
                <div className="search-wrapper">
                  <img
                    className="location-icon"
                    src="images/location-icon.svg"
                    alt=""
                  />
                  <select className="location-select">
                    <option>Your location</option>
                    <option>New Delhi</option>
                    <option>Mumbai</option>
                    <option>Bangalore</option>
                  </select>

                  <input
                    type="text"
                    className="search-input"
                    placeholder="What you are looking for?"
                  />
                  <button className="search-btn">
                    <img src="images/search-icon.svg" alt="" />
                  </button>
                </div>
              </div>
              <div className="col-md-12">
                <p className="subtext">
                  From photos to documents - print and get it delivered to your
                  doorstep.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-us-section padd-y">
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <div className="about-uscontent">
                <p>About Us</p>
                <h2>
                  From documents to photos - delivered when you need them.
                </h2>
                <p>
                  <span>
                    From passport photos to custom prints, we connect you with
                    nearby print vendors for fast, reliable, and high-quality
                    results. Whether you're at home or on the go, get your
                    prints delivered right to your doorstep.
                  </span>
                </p>
              </div>
              <div className="happy-customer">
                <p className="happy-title">Our Happy Customers</p>
                <div className="d-flex aic">
                  <div className="happy-wrap">
                    <div className="happy-wrap-per">
                      <img src="images/person-logo.png" alt="/" />
                    </div>
                    <div className="happy-wrap-per">
                      <img src="images/person-logo.png" alt="/" />
                    </div>
                    <div className="happy-wrap-per">
                      <img src="images/person-logo.png" alt="/" />
                    </div>
                  </div>
                  <div className="star-rating">
                    <img src="images/start-icon.svg" alt="/" />
                    <div className="rating-context">
                      <p>
                        4.8 <br /> <small>(19k reviews)</small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-7">
              <div className="about-usImg">
                <img src="images/about-us-img.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="joinus-section">
        <div className="row h-100">
          <div className="col-md-7 p-0">
            <video autoPlay muted loop id="videolayout">
              <source src="images/packing-video.mp4" type="video/mp4" />
            </video>
          </div>
          <div className="col-md-5 p-0">
            <div className="joinus-wrap">
              <div className="row h-100">
                <div className="col-md-12">
                  <div className="joinus-context">
                    <p>Join us now!</p>
                    <h2>Documents, Photos & More. Delivered Fast!</h2>
                  </div>
                </div>
                <div className="col-md-12 mt-auto">
                  <div className="joinus-link">
                    <p>Download Now for Android & iOS</p>
                    <div className="joinus-link-btn">
                      <div className="row">
                        <div className="col-md-5">
                          <button className="btn btn-download btn-block">
                            <img src="images/google-downloadimg.png" alt="/" />
                          </button>
                        </div>
                        <div className="col-md-5">
                          <button className="btn btn-download btn-block">
                            <img src="images/ios-downloadimg.png" alt="/" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about-us-section padd-y">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="about-uscontent">
                <p>Our Services</p>
                <h2>
                  Simply upload your files, choose a nearby print shop, and get
                  your prints delivered to your doorstep - fast, secure, and
                  hassle-free.
                </h2>
              </div>
            </div>
            <div className="hover-card-bw">
              <div className="row">
                <div className="col">
                  <div className="hover-card">
                    <div className="row h-100">
                      <div className="col-md-12">
                        <h5>Documents</h5>
                        <p>
                          Print PDFs, forms, and certificates with ease. Select
                          paper type and get professional-quality prints.
                        </p>
                      </div>
                      <div className="col-md-12 mt-auto">
                        <img src="images/hover-card-icon.svg" alt="/" />
                        <img
                          className="img-hover"
                          src="images/hover-h-card-icon.png"
                          alt="/"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col">
                  <div className="hover-card">
                    <div className="row h-100">
                      <div className="col-md-12">
                        <h5>Passport photos</h5>
                        <p>
                          Get passport-size photos that meet official
                          guidelines. Upload your image or get clicked at a
                          nearby vendor.
                        </p>
                      </div>
                      <div className="col-md-12 mt-auto">
                        <img src="images/hover-card-icon-2.svg" alt="/" />
                        <img
                          className="img-hover"
                          src="images/hover-h-card-icon-2.png"
                          alt="/"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="hover-card">
                    <div className="row h-100">
                      <div className="col-md-12">
                        <h5>Notary</h5>
                        <p>
                          Easily access licensed notary services for your
                          documents. Book online and get your papers notarized.
                        </p>
                      </div>
                      <div className="col-md-12 mt-auto">
                        <img src="images/hover-card-icon-3.png" alt="/" />
                        <img
                          className="img-hover"
                          src="images/hover-h-card-icon-3.png"
                          alt="/"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="hover-card">
                    <div className="row h-100">
                      <div className="col-md-12">
                        <h5>Photography</h5>
                        <p>
                          Book professional photography for events, portraits,
                          or product shoots. Choose local photographers,
                          schedule easily.
                        </p>
                      </div>
                      <div className="col-md-12 mt-auto">
                        <img src="images/hover-card-icon-4.svg" alt="/" />
                        <img
                          className="img-hover"
                          src="images/hover-h-card-icon-4.png"
                          alt="/"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="hover-card">
                    <div className="row h-100">
                      <div className="col-md-12">
                        <h5>Hyperlocal</h5>
                        <p>
                          We connect you with nearby print and service providers
                          for faster delivery. Convenient and tailored to your
                          local needs.
                        </p>
                      </div>
                      <div className="col-md-12 mt-auto">
                        <img src="images/hover-card-icon-5.svg" alt="/" />
                        <img className="img-hover" src="images/hover-h-card-icon-5.png" alt="/" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="how-section padd-y">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="works">
                <div className="howworks-head">
                  <img src="/images/howwe-img.png" alt="/" />
                  <h4>How we works?</h4>
                </div>
                <div className="howworks-wrapper padd-top">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="howworks-wrap">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="work-icon">
                              <img src="images/works-icon-1.png" alt="/" />
                            </div>
                          </div>
                          <div className="col-md-9">
                            <div className="howworks-wrap-context">
                              <h1>01.</h1>
                              <div className="border-in"></div>
                              <p>Select Shop</p>
                              <p>
                                <span>
                                  Pick a nearby print vendor for quick
                                  processing and delivery.
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="howworks-wrap">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="work-icon work-icon-2">
                              <img src="images/works-icon-2.png" alt="/" />
                            </div>
                          </div>
                          <div className="col-md-9">
                            <div className="howworks-wrap-context">
                              <h1>02.</h1>
                              <div className="border-in"></div>
                              <p>Upload Files</p>
                              <p>
                                <span>
                                  Choose your service and upload documents or
                                  photos with preferred settings.
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="howworks-wrap">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="work-icon work-icon-3">
                              <img src="images/works-icon-3.png" alt="/" />
                            </div>
                          </div>
                          <div className="col-md-9">
                            <div className="howworks-wrap-context">
                              <h1>03.</h1>
                              <div className="border-in"></div>
                              <p>Select Shop</p>
                              <p>
                                <span>
                                  Receive high-quality prints at your doorstep
                                  or pick them up from the shop.
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </>
  );
};

export default HomePage;
